/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ContainerPositionType = {
    Vessel: 'Vessel',
    Truck: 'Truck',
    Yard: 'Yard',
    Equipment: 'Equipment',
    Handover: 'Handover',
    Unknown: 'Unknown',
    Berth: 'Berth',
    Repair: 'Repair',
    Warehouse: 'Warehouse',
    Customs: 'Customs',
    Weights: 'Weights',
    RequireYardReservation: 'RequireYardReservation',
    Train: 'Train',
} as const;

export type ContainerPositionType = typeof ContainerPositionType[keyof typeof ContainerPositionType];



